import { defineMessages } from 'react-intl';

export default defineMessages({
  'daily' : {
    'id' : 'period.daily',
    'defaultMessage' : 'Daily'
  },
  'weekly' : {
    'id' : 'period.weekly',
    'defaultMessage' : 'Weekly'
  },
  'monthly' : {
    'id' : 'period.monthly',
    'defaultMessage' : 'Monthly'
  },
  'quarterly' : {
    'id' : 'period.quarterly',
    'defaultMessage' : 'Quarterly'
  },
  'half_yearly' : {
    'id' : 'period.half_yearly',
    'defaultMessage' : 'Half yearly'
  },
  'yearly' : {
    'id' : 'period.yearly',
    'defaultMessage' : 'Yearly'
  },
});





